export default __webpack_public_path__ + "static/media/Date_Black.2d1568f8.webp";